module.exports = __webpack_public_path__ + "static/introduction_logo-d7ac86281a3e6add99b0da547217deac.png";